import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// @mui
import { Collapse, Stack } from "@mui/material";
import { Icon } from "@mdi/react";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
// hooks
import useActiveLink from "../../../hooks/useActiveLink";
//
import NavItem from "./NavItem";

// ----------------------------------------------------------------------

NavList.propTypes = {
  data: PropTypes.object,
  depth: PropTypes.number,
  hasChild: PropTypes.bool,
};

export default function NavList({ data, depth, hasChild }) {
  const { pathname } = useLocation();

  const { active } = useActiveLink(data.path);

  const [open, setOpen] = useState(active);

  useEffect(() => {
    if (!active) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Stack
      sx={{
        borderRadius: 1,
        ...(hasChild && {
          background: "#FFFFFF10",
          padding: 1,
          gap: 1,
        }),
      }}
    >
      <NavItem item={data} depth={depth} open={open} active={active} />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.routes} depth={depth} />
        </Collapse>
      )}
      {hasChild && (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          onClick={handleToggle}
        >
          {open ? (
            <Icon path={mdiChevronUp} size={2} color="white" />
          ) : (
            <Icon path={mdiChevronDown} size={2} color="white" />
          )}
        </Stack>
      )}
    </Stack>
  );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
  data: PropTypes.array,
  depth: PropTypes.number,
};

function NavSubList({ data, depth }) {
  return (
    <>
      {data.map((list) => (
        <NavList
          key={list.label + list.path}
          data={list}
          depth={depth + 1}
          hasChild={list.areSubRoutesGroupedSidebarTabs}
        />
      ))}
    </>
  );
}
